import React, { useGlobal, useState, useEffect } from "reactn";
import { ReportTable } from "../../../components/UI/reportsAnalytics";
import { CSVLink } from "react-csv";
import { useCancellableRequest } from "../../../utilities/hooks/useCancellableRequest";

const CartReport = () => {
  const [partnerPathway, setPartnerPathway] = useGlobal("partnerPathway");
  const [loading, setLoading] = useGlobal("loading");
  const [reportData, setReportData] = useState([]);
  const [hasGenerated, setHasGenerated] = useState(false);
  const { makeRequest } = useCancellableRequest();

  useEffect(() => {
    setPartnerPathway([
      ...partnerPathway.slice(0, 1),
      { label: "Reports & Analytics", to: "/reporting" },
      { label: "Cart Report", to: "/reports/cart-report" }
    ]);
  }, []);

  const handleGenerate = async () => {
    setLoading(true);
    try {
      const result = await makeRequest({
        method: 'get',
        url: `${process.env.REACT_APP_API}/partners/orders/cart-report`
      });

      if (!result) return;

      if (result.data.success) {
        setReportData(result.data.data);
        setHasGenerated(true);
      } else {
        console.error("Error generating cart report:", result.data.message);
      }
    } catch (error) {
      console.error('Error fetching cart report:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGenerate();
  }, []);

  const formatDaysAgo = daysAgo => {
    if (daysAgo === null || daysAgo === undefined) return "N/A";
    if (daysAgo === 0) return "Today";
    if (daysAgo === 1) return "1 day ago";
    return `${daysAgo} days ago`;
  };

  const formatData = (data) => {
    return data.map(row => [
      row.displayName || "N/A",
      row.email || "N/A",
      formatDaysAgo(row.daysAgo),
      row.itemName || "N/A"
    ]);
  };

  const getCsvData = (data) => {
    return data.map(row => ({
      displayName: row.displayName || "N/A",
      email: row.email || "N/A",
      daysAgo: formatDaysAgo(row.daysAgo),
      itemName: row.itemName || "N/A"
    }));
  };

  const csvHeaders = [
    { label: "Display Name", key: "displayName" },
    { label: "Email", key: "email" },
    { label: "Last interacted With", key: "daysAgo" },
    { label: "Item Name", key: "itemName" }
  ];

  return (
    <div className="admin">
      <div className="container-fluid adminprofiles">
        <div className="row cont">
          <div className="col-md-6">
            <h1>Abandoned Cart Analytics</h1>
          </div>
        </div>
      </div>

      <div style={{display: "flex", justifyContent: "center"}} className="container-fluid my_earning">
        <div className="cont report-card">
          <div className="report-container">
            <div className="report-section larger">
              <div className="export-button-section" style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
                {hasGenerated && reportData.length > 0 && (
                  <CSVLink
                    headers={csvHeaders}
                    data={getCsvData(reportData)}
                    filename={`Cart_Report_${new Date().toISOString().split('T')[0]}.csv`}
                  >
                    <button className="filter-button" disabled={loading}>Export</button>
                  </CSVLink>
                )}
              </div>
              <div className="report-top-section">
                <h3 id="table-title" className="report-heading">Customers</h3>
              </div>
              {hasGenerated ? (
                reportData.length > 0 ? (
                  <ReportTable
                    headings={[
                      { label: "Display Name", className: "table-item-bold" },
                      { label: "Email", className: "table-item-bold" },
                      { label: "Last Interacted With", className: "table-item-bold" },
                      { label: "Item Name", className: "table-item-bold" }
                    ]}
                    body={formatData(reportData)}
                  />
                ) : (
                  <div style={{ padding: "20px", textAlign: "center" }}>
                    <p>No users found who removed items from their cart.</p>
                  </div>
                )
              ) : (
                <div style={{ padding: "20px", textAlign: "center" }}>
                  <p>Loading data...</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartReport;
